<template>
  <div
    aria-labelledby="myModalLabel"
    class="modal fade previewer"
    id="img_preview"
    role="dialog"
    tabindex="-1"
  >
    <div class="modal-dialog" role="document">
      <div class="viewer">
        <div class="viewer-toolbar">
          <div class="dropdown pull-left mobile-menu">
            <a data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
              <i class="iconfont icon-list"></i>
            </a>
            <ul class="dropdown-menu" aria-labelledby="dropdownMenu1">
              <li v-show="showDownload">
                <a @click="downloadImg"> <i class="ti-download"></i>下载 </a>
              </li>
              <li v-show="showShare">
                <a @click="handlePreviewData('share')">
                  <i class="iconfont icon-share"></i>分享
                </a>
              </li>
              <li v-show="showMoveCopy">
                <a @click="handlePreviewData('move')">
                  <i class="iconfont icon-move"></i>移动
                </a>
              </li>

              <li v-show="showMoveCopy">
                <a @click="handlePreviewData('copy')">
                  <i class="iconfont icon-copy"></i>复制
                </a>
              </li>
              <li v-show="showDelete">
                <a @click="deletePreviewData">
                  <i class="iconfont icon-trash"></i>删除
                </a>
              </li>
            </ul>
          </div>

          <div class="pull-left menu tool">
            <a
              @click="downloadImg"
              data-toggle="tooltip"
              data-placement="bottom"
              v-show="showDownload"
              title="下载"
            >
              <i class="ti-download"></i>
            </a>
            <a
              @click="handlePreviewData('share')"
              v-show="showShare"
              data-toggle="tooltip"
              data-placement="bottom"
              title="分享"
            >
              <i class="iconfont icon-share"></i>
            </a>
            <a
              @click="handlePreviewData('move')"
              v-show="showMoveCopy"
              data-toggle="tooltip"
              data-placement="bottom"
              title="移动"
            >
              <i class="iconfont icon-move"></i>
            </a>
            <a
              @click="handlePreviewData('copy')"
              v-show="showMoveCopy"
              data-toggle="tooltip"
              data-placement="bottom"
              title="复制"
            >
              <i class="iconfont icon-copy"></i>
            </a>
            <a
              @click="deletePreviewData"
              v-show="showDelete"
              data-toggle="tooltip"
              data-placement="bottom"
              title="删除"
            >
              <i class="iconfont icon-trash"></i>
            </a>
          </div>

          <div class="pull-right tool">
            <a
              @click="close"
              data-toggle="tooltip"
              data-placement="bottom"
              title="关闭"
            >
              <i class="iconfont icon-close"></i>
            </a>
          </div>
          <div class="dropdown pull-right">
            <a data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
              <i class="iconfont icon-more"></i>
            </a>
            <ul
              class="dropdown-menu dropdown-menu-right"
              aria-labelledby="dropdownMenu1"
            >
              <li>
                <a @click="originalSize"> <i class="ti-image"></i>原始尺寸 </a>
              </li>
              <li>
                <a @click="initWidthHeight">
                  <i class="ti-layout-slider-alt"></i>自适应尺寸
                </a>
              </li>
            </ul>
          </div>

          <div class="pull-right tool pagemenu">
            <a @click="prev">上一页</a>
            <span>{{ imgIndex }} / {{ imgsLength }}</span>
            <a @click="next">下一页</a>
          </div>

          <div class="cont">
            <a @click="prev" class="prev">
              <i class="ti-angle-left"></i>
            </a>

            <div class="name">
              <h4>{{ data.name }}.{{ data.file_ext }}</h4>
              <p>{{ imgIndex }} / {{ imgsLength }}</p>
            </div>

            <a @click="next" class="next">
              <i class="ti-angle-right"></i>
            </a>
          </div>
        </div>

        <div class="viewer-body">
          <div id="carousel-example-generic" ref="mb" class="carousel slide">
            <div class="loadingbox" v-show="loading">
              <section class="loading Animation1">
                <section class="shape shape-1"></section>
                <section class="shape shape-2"></section>
                <section class="shape shape-3"></section>
                <section class="shape shape-4"></section>
              </section>
              <h4>正在加载，请稍后……</h4>
            </div>
            <div class="carousel-inner" role="listbox">
              <div class="item active">
                <img
                  id="imgone"
                  ref="img"
                  v-show="!loading && !data.is_lock && !errorLoading"
                  :src="preview_path"
                  @load="loaded"
                />
                <p v-show="data.is_lock || errorLoading">{{ lockReason }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
const errorImg = require("@/assets/images/image-not-found.png");
import Cookies from "js-cookie";
import { preview, download } from "@/api/drive/drive";
import {
  sharePreview,
  shareDownload,
  linkTargetPreview,
  linkTargetDownload,
} from "@/api/share/share";
import { getRolePermissions } from "@/utils/permission";
export default {
  name: "imgPreview",
  props: {
    imgs: {
      type: Array,
    },
    linkShareNumber: {
      type: String,
    },
  },
  data() {
    return {
      errorLoading: false,
      lockReason: "",
      loading: true,
      data: {},
      preview_path: "",
      category: "",
      is_preview: "",
      storeDatas: [],
    };
  },
  computed: {
    user() {
      return this.$store.state.user.userInfo;
    },
    showShare() {
      return (
        (["file", "star"].indexOf(this.tab) > -1 &&
          this.$route.name !== "sharelink" &&
          this.$route.name !== "sendlink") ||
        this.$route.name === "images"
      );
    },
    showMoveCopy() {
      return (
        (["file", "star"].indexOf(this.tab) > -1 &&
          this.$route.name !== "sharelink" &&
          this.$route.name !== "sendlink") ||
        this.$route.name === "images"
      );
    },
    showDownload() {
      if (
        (["file", "star"].indexOf(this.tab) > -1 &&
          this.$route.name !== "sharelink" &&
          this.$route.name !== "sendlink") ||
        this.$route.name === "images"
      ) {
        return true;
      } else if (this.showOnGroupFile) {
        if (this.permissions.resource_operations === "ALL") {
          return true;
        }
        if (this.data.number && this.data.parent_number) {
          let number = this.data.number;
          if (this.data.parent_number != "0") {
            if (this.data.parent_path_number) {
              number = this.data.parent_path_number.slice(1, 37);
            } else {
              // 创建文件夹时，直接给权限
              return true;
            }
          }
          let resource = this.permissions.resource_operations.find((item) => {
            return item.folder_id === number;
          });
          if (resource) {
            let permissions = getRolePermissions(resource.role_type);
            return permissions.indexOf("downloadResource") > -1;
          }
          return false;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    showDelete() {
      if (
        (["file", "star"].indexOf(this.tab) > -1 &&
          this.$route.name !== "sharelink" &&
          this.$route.name !== "sendlink") ||
        this.$route.name === "images"
      ) {
        return true;
      } else if (this.showOnGroupFile) {
        if (this.permissions.resource_operations === "ALL") {
          return true;
        }
        if (this.data.number && this.data.parent_number) {
          let number = this.data.number;
          if (this.data.parent_number != "0") {
            if (this.data.parent_path_number) {
              number = this.data.parent_path_number.slice(1, 37);
            } else {
              // 创建文件夹时，直接给权限
              return true;
            }
          }
          let resource = this.permissions.resource_operations.find((item) => {
            return item.folder_id === number;
          });
          if (resource) {
            let permissions = getRolePermissions(resource.role_type);
            return permissions.indexOf("deleteResource") > -1;
          }
          return false;
        } else {
          return false;
        }
      }
      return false;
    },
    groupNumber() {
      return this.$store.state.drive.groupNumber;
    },
    shareNumber() {
      return this.$store.state.drive.share.share_number;
    },
    imgsLength() {
      return this.imgs.length;
    },
    imgIndex() {
      return this.imgs.indexOf(this.data) + 1;
    },
    tab() {
      return this.$store.state.drive.tab;
    },
    showOnGroupFile: function () {
      return this.tab === "group-file" || this.tab === "groupdisk-file";
    },
    permissions() {
      return this.$store.state.group.permissions;
    },
  },
  methods: {
    // 设置为原始尺寸
    originalSize() {
      let img = this.$refs.img;
      img.style.width = this.naturalWidth + "px";
      img.style.height = this.naturalHeight + "px";
    },
    // 初始化图片的尺寸
    initWidthHeight() {
      let maxWidth = $(this.$refs.mb).width();
      let maxHeight = $(this.$refs.mb).height();
      let img = this.$refs.img;
      if (this.naturalWidth > 0 && this.naturalHeight > 0) {
        //原图片宽高比例 大于 指定的宽高比例，这就说明了原图片的宽度必然 > 高度
        if (this.naturalWidth / this.naturalHeight >= maxWidth / maxHeight) {
          if (this.naturalWidth > maxWidth) {
            img.style.width = maxWidth + "px";
            // 按原图片的比例进行缩放
            img.style.height =
              (this.naturalHeight * maxWidth) / this.naturalWidth + "px";
          } else {
            // 按原图片的大小进行缩放
            img.style.width = this.naturalWidth + "px";
            img.style.height = this.naturalHeight + "px";
          }
        } else {
          // 原图片的高度必然 > 宽度
          if (this.naturalHeight > maxHeight) {
            img.style.height = maxHeight + "px";
            // 按原图片的比例进行缩放
            img.style.width =
              (this.naturalWidth * maxHeight) / this.naturalHeight + "px";
          } else {
            // 按原图片的大小进行缩放
            img.style.width = this.naturalWidth + "px";
            img.style.height = this.naturalHeight + "px";
          }
        }
      }
    },
    loaded() {
      this.loading = false;
      this.errorLoading = false;
      const image = new Image();
      image.src = this.preview_path;
      image.onload = () => {
        this.naturalWidth = image.width;
        this.naturalHeight = image.height;
        this.initWidthHeight();
      };
    },
    handlePreviewData(action) {
      this.close();
      this.$emit("handlePreviewData", {
        type: "img",
        action: action,
        data: this.data,
      });
    },
    prev() {
      // this.preview_path = "";
      let index = this.imgIndex === 1 ? false : this.imgIndex - 2;
      if (index !== false) {
        this.data = this.imgs[index];
        let that = this;
        let data = this.storeDatas.find(
          (item) => item.number === that.data.number
        );
        if (data) {
          this.preview_path = data.preview_path;
        } else if (this.data.is_lock) {
          this.preview_path = "";
          this.lockReason = this.data.lock_reason
            ? this.data.lock_reason
            : "该图片已被锁定";
        } else {
          if (this.$route.name === "sendlink") {
            this.sendPreview();
          } else if (this.shareNumber || this.$route.name === "sharelink") {
            this.sharePreview();
          } else {
            this.preview();
          }
        }
      } else {
        this.$message({
          type: "success",
          message: "已经是第一张",
        });
      }
    },
    next() {
      // this.preview_path = "";
      let index = this.imgIndex === this.imgs.length ? false : this.imgIndex;
      if (index) {
        this.data = this.imgs[index];
        let that = this;
        let data = this.storeDatas.find(
          (item) => item.number === that.data.number
        );
        if (data) {
          this.preview_path = data.preview_path;
        } else if (this.data.is_lock) {
          this.preview_path = "";
          this.lockReason = this.data.lock_reason
            ? this.data.lock_reason
            : "该图片已被锁定";
        } else {
          if (this.$route.name === "sendlink") {
            this.sendPreview();
          } else if (this.shareNumber || this.$route.name === "sharelink") {
            this.sharePreview();
          } else {
            this.preview();
          }
        }
      } else {
        this.$message({
          type: "success",
          message: "已经是最后一张",
        });
      }
    },
    close() {
      $("#img_preview").modal("hide");
    },
    // 发布预览
    sendPreview() {
      this.loading = true;
      linkTargetPreview({
        link_number: this.linkShareNumber,
        link_resource_number: this.data.number,
        link_constraint: {
          password: Cookies.get(this.linkShareNumber),
        },
      })
        .then((res) => {
          if (res.status_code === 200) {
            this.storeDatas.push({
              number: this.data.number,
              preview_path: res.entity.preview_path,
            });
            this.preview_path = res.entity.preview_path;
            this.category = res.entity.category;
            this.is_preview = res.entity.is_preview;
          } else {
            this.loading = false;
            this.errorLoading = true;
            this.lockReason = "图片加载出错了";
          }
        })
        .catch(() => {
          this.loading = false;
          this.errorLoading = true;
          this.lockReason = "图片加载出错了";
        });
    },
    // 分享预览
    sharePreview() {
      this.loading = true;
      let share_constraint, share_number;
      if (this.$route.name === "sharelink") {
        share_number = this.linkShareNumber;
        share_constraint = {
          password: Cookies.get(this.linkShareNumber),
        };
      } else {
        share_number = this.shareNumber;
        share_constraint = null;
      }
      sharePreview({
        share_number: share_number,
        share_resource_number: this.data.number,
        share_constraint: share_constraint,
      })
        .then((res) => {
          if (res.status_code === 200) {
            this.storeDatas.push({
              number: this.data.number,
              preview_path: res.entity.preview_path,
            });
            this.preview_path = res.entity.preview_path;
            this.category = res.entity.category;
            this.is_preview = res.entity.is_preview;
          } else {
            this.loading = false;
            this.errorLoading = true;
            this.lockReason = "图片加载出错了";
          }
        })
        .catch(() => {
          this.loading = false;
          this.errorLoading = true;
          this.lockReason = "图片加载出错了";
        });
    },
    // 云盘预览
    preview() {
      this.loading = true;
      preview({
        number: this.data.number,
        group_number: this.groupNumber,
      })
        .then((res) => {
          if (res.status_code === 200) {
            this.storeDatas.push({
              number: this.data.number,
              preview_path: res.entity.preview_path,
            });
            this.preview_path = res.entity.preview_path;
            this.category = res.entity.category;
            this.is_preview = res.entity.is_preview;
          } else {
            this.loading = false;
            this.errorLoading = true;
            this.lockReason = "图片加载出错了";
          }
        })
        .catch(() => {
          this.loading = false;
          this.errorLoading = true;
          this.lockReason = "图片加载出错了";
        });
    },
    /**
     * 使用download下载的3个地方
     * 1、云盘: route:recdrive, tab:[file, star, sharefile]
     * 2、群盘: route:group, tab:[group-file, groupdisk-file]
     * 3、个人中心: route:persona, tab:[persona-file]
     * 4、应用：route:[ppt, word, excel, images, videos]
     * 使用shareDownload下载的4个地方
     * 1、云盘: route:recdrive, tab:[shareme]
     * 2、群盘: route:group, tab:[group-share, groupdisk-share, group-send, groupdisk-send]
     * 3、个人中心: route:persona, tab:[persona-sharefile]
     * 4、分享链接: route:sharelink
     */
    downloadImg() {
      switch (this.$route.name) {
        case "recdrive":
          if (
            ["file", "star", "sharefile"].indexOf(this.$store.state.drive.tab) >
            -1
          ) {
            this.download();
          } else if ("shareme" === this.$store.state.drive.tab) {
            this.shareDownload();
          }
          break;
        case "group":
          if (
            ["group-file", "groupdisk-file"].indexOf(
              this.$store.state.drive.tab
            ) > -1
          ) {
            this.download();
          } else if (
            [
              "group-share",
              "groupdisk-share",
              "group-send",
              "groupdisk-send",
            ].indexOf(this.$store.state.drive.tab) > -1
          ) {
            this.shareDownload();
          }
          break;
        case "persona":
          if ("persona-file" === this.$store.state.drive.tab) {
            this.download();
          } else if ("persona-sharefile" === this.$store.state.drive.tab) {
            this.shareDownload();
          }
          break;
        case "sharelink":
          this.shareDownload();
          break;
        case "sendlink":
          this.sendDownload();
          break;
        default:
          // route:[ppt, word, excel, images, videos]
          this.download();
          break;
      }
    },
    // 云盘资源下载
    download() {
      let params = {
        files_list: [this.data.number],
        group_number: this.groupNumber,
      };
      download(params)
        .then((res) => {
          if (res.status_code === 200) {
            window.location.href =
              res.entity[this.data.number] + "&download=download";
          } else {
            this.$message({
              type: "error",
              message: res.message,
            });
          }
        })
        .catch((err) => {
          this.$message({
            type: "error",
            message: err,
          });
        });
    },
    // 分享资源下载
    shareDownload() {
      let params = {
        share_resources_list: [this.data.number],
      };
      if (this.$route.name === "sharelink") {
        params.share_number = this.linkShareNumber;
        params.share_constraint = {
          password: Cookies.get(this.linkShareNumber),
        };
      } else {
        params.share_number = this.shareNumber;
      }
      shareDownload(params)
        .then((res) => {
          if (res.status_code === 200) {
            window.location.href =
              res.entity[this.data.number] + "&download=download";
          } else {
            this.$message({
              type: "error",
              message: res.message,
            });
          }
        })
        .catch((err) => {
          this.$message({
            type: "error",
            message: err,
          });
        });
    },
    // 发布资源下载
    sendDownload() {
      let params = {
        link_number: this.linkShareNumber,
        link_constraint: {
          ip: null,
          host: null,
          password: Cookies.get(this.linkShareNumber),
        },
        link_resources_list: [this.data.number],
      };
      linkTargetDownload(params)
        .then((res) => {
          if (res.status_code === 200) {
            window.location.href =
              res.entity[this.data.number] + "&download=download";
          } else {
            this.$message({
              type: "error",
              message: res.message,
            });
          }
        })
        .catch((err) => {
          this.$message({
            type: "error",
            message: err,
          });
        });
    },
    deletePreviewData() {
      this.$confirm({
        type: "confirm",
        content: `确定删除吗？`,
        showCancleBtn: true,
        showYesBtn: true,
        custom: [],
      })
        .then(() => {
          this.$store.commit("operationFileOrFolderData", {
            group_number: this.groupNumber,
            action: this.showOnGroupFile ? "delete" : "recycle",
            disk_type: "cloud",
            files_list: [
              {
                number: this.data.number,
                type: this.data.type,
              },
            ],
          });
          this.$store
            .dispatch("handleFileOrFolder", this.data)
            .then((res) => {
              if (res.status_code === 200) {
                this.$store.commit("deleteFileOrFolder", this.data);
                if (this.imgs.length === 1) {
                  this.$emit("deletePreviewData", 1);
                  this.close();
                } else if (this.imgIndex === this.imgs.length) {
                  this.prev();
                  this.$emit("deletePreviewData", this.imgs.length - 1);
                } else {
                  this.next();
                  this.$emit("deletePreviewData", this.imgIndex - 2);
                }
                this.$message({
                  type: "success",
                  message: res.message,
                });
              } else {
                this.$message({
                  type: "error",
                  message: res.message,
                });
              }
            })
            .catch((err) => {
              this.$message({
                type: "error",
                message: err,
              });
            });
        })
        .catch(() => {});
    },
    MouseWheelHandler(e) {
      let img = this.$refs.img;
      let el = window.event || e;
      let delta = Math.max(-1, Math.min(1, el.wheelDelta || -el.detail));

      let maxWidth = $(this.$refs.mb).width();
      let maxHeight = $(this.$refs.mb).height();
      if (this.naturalWidth > 0 && this.naturalHeight > 0) {
        if (this.naturalWidth / this.naturalHeight >= maxWidth / maxHeight) {
          // 原图片宽高比例 大于 指定的宽高比例，以maxWidth为自适应宽度
          let width = delta > 0 ? img.width * 1.1 : img.width * 0.9;
          if (width < this.naturalWidth && width < 30) {
            width = 30;
          }
          if (width < maxWidth || width < this.naturalWidth * 1.5) {
            img.style.width = width + "px";
            img.style.height =
              (this.naturalHeight * width) / this.naturalWidth + "px";
          } else {
            img.style.width = maxWidth + "px";
            img.style.height =
              (this.naturalHeight * maxWidth) / this.naturalWidth + "px";
          }
        } else {
          // 原图片宽高比例 小于 指定的宽高比例，以maxHeight为自适应宽度
          let height = delta > 0 ? img.height * 1.1 : img.height * 0.9;
          if (height < this.naturalHeight && height < 30) {
            height = 30;
          }
          if (height < maxHeight || height < this.naturalHeight * 1.5) {
            img.style.height = height + "px";
            img.style.width =
              (this.naturalWidth * height) / this.naturalHeight + "px";
          } else {
            img.style.height = maxHeight + "px";
            img.style.width =
              (this.naturalWidth * height) / this.naturalHeight + "px";
          }
        }
      }
      return false;
    },
  },
  mounted() {
    $(function () {
      $("#imgone").on("error", function () {
        $(this).attr("src", errorImg);
        $(this).css({ height: "160px", width: "160px" });
      });
      $('[data-toggle="tooltip"]').tooltip();
    });
    let mb = this.$refs.mb;
    if (mb.addEventListener) {
      // IE9, Chrome, Safari, Opera
      mb.addEventListener("mousewheel", this.MouseWheelHandler, false);
      // Firefox
      mb.addEventListener("DOMMouseScroll", this.MouseWheelHandler, false);
    } else {
      // IE 6/7/8
      mb.attachEvent("onmousewheel", this.MouseWheelHandler);
    }
    $("#img_preview").on("show.bs.modal", () => {
      this.$emit("changePreviewStatus", true);
      this.data = this.imgs.find((item) => item.show === true);
      // console.log(this.$route.name);
      if (this.$route.name === "sendlink") {
        this.sendPreview();
      } else if (
        (this.shareNumber && this.tab != "sharefile") ||
        this.$route.name === "sharelink"
      ) {
        this.sharePreview();
      } else {
        this.preview();
      }
    });
    $("#img_preview").on("hidden.bs.modal", () => {
      this.$emit("changePreviewStatus", false);
    });
  },
  destroyed() {
    $("#imgone").off();
    $("#img_preview").off();
  },
};
</script>

<style scoped>
.loadingbox {
  position: relative;
  top: 25%;
}
.viewer-body p {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  width: 50%;
  height: 14%;
  margin: auto;
  color: #eee;
  font-size: 5rem;
  text-align: center;
}
</style>